module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Store Dwell Time"}}')
  delete Component.options._Ctor
}
